export const HOSPITAL_ESTADUAL_DA_CRIANCA_SYS_ID = '3d535ab5fe1bfa7810bcd687bfe54bcb34'

export const HOSPITAL_ESTADUAL_DA_CRIANCA_DISPLAY_NAME =
  'RJ - Hospital Estadual da Criança'

export const LOCATION_REOPEN_BLOCKED_MESSAGE =
  'Notificações do RJ - Hospital Estadual da Criança não podem ser reabertas.'

type LocationReference = {
  value?: string
  display_value?: string
}

export function isLocationReopenBlocked(
  location?: LocationReference | string
): boolean {
  if (!location) {
    return false
  }

  const locationId = typeof location === 'string' ? location : location.value
  const locationDisplayValue =
    typeof location === 'string' ? undefined : location.display_value

  if (
    locationId &&
    locationId.toLowerCase() === HOSPITAL_ESTADUAL_DA_CRIANCA_SYS_ID.toLowerCase()
  ) {
    return true
  }

  return locationDisplayValue === HOSPITAL_ESTADUAL_DA_CRIANCA_DISPLAY_NAME
}

export function shouldShowLocationReopenBlockedAlert(
  notificationStatusState: string,
  location?: LocationReference | string
): boolean {
  const isFinishedOrArchived =
    notificationStatusState === 'Finalizada' ||
    notificationStatusState === 'Arquivada'

  return isFinishedOrArchived && isLocationReopenBlocked(location)
}

export function groupHasLocationReopenBlocked(
  notifications?: Array<{ location_incident?: LocationReference }>
): boolean {
  return (
    notifications?.some(notification =>
      isLocationReopenBlocked(notification.location_incident)
    ) ?? false
  )
}
